<div>
    <div class="main-section cx-one-ui">
        <div class="form-container cx-one-ui">
            <form [formGroup]="complexNumericForm" id="reporting-set-data-field" *ngIf="!showFunctionOperatorField">
                <div class="input-field">
                    <label for="formula-field" id="field-formula-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Formula_Components">FORMULA COMPONENTS</label> <span class="field-required"> * </span>
                    <div class="row list-item" *ngFor="let item of parentData?.formulas">
                        <ng-container *ngTemplateOutlet="addedList; context: { $implicit: item }"> </ng-container>
                    </div>
                    <div class="row list-item">
                        <ng-container *ngTemplateOutlet="emptyList"> </ng-container>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <ng-template #addedList let-item>
        <div class="col-10 add-field-box">
            <p class="row" style="color: #333333;" *ngIf="item.numericType === 'expression'">
                {{item?.functionType?.label}}({{item?.childs[0]?.name?.replaceAll('"','')}})</p>
            <p class="row" style="color: #333333;" *ngIf="item.numericType === 'operation'">
                <span cvLocalizedText langSection="ETL_Reporting_Set" langKey="Operation_Symbol">Operation</span>
                <span>: {{operationSymbols[item?.operations?.label]}} {{item?.operations?.label}}</span>
            </p>
        </div>
        <div class="col-2 cursor-pointer icon-container">
            <svg class="icon edit-icon" (click)="editFormula(item)">
                <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
            </svg>
        </div>
    </ng-template>
    <ng-template #emptyList>
        <div class="col-10 add-field-box">
            <p class="row" style="color: #6D6D6D;" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Input_Field_Placeholder">Add input</p>
        </div>
        <div class="col-2 cursor-pointer icon-container">
            <svg class="icon add-icon icon-14" (click)="addNewField()">
                <use href="../App_Themes/CXone/icons/add.svg#add"></use>
            </svg>
        </div>
    </ng-template>

    <ng-container *ngIf="showFunctionOperatorField">
        <button class="button back-btn" (click)="backBtn()" cvLocalizedText langSection="ETL_Reporting_Set"
            langKey="Back">Back</button>

        <cv-function-operator-field (addChilds)="addComplexNumericChild()" [numericData]="numericData"
            (editInput)="editExist($event)" (formChanged)="formValueChanged()"></cv-function-operator-field>
    </ng-container>
</div>